import { z } from 'zod';

import { orderIdSchema, orderLogsResultSchema } from '../orderLogs.mts';
import { AvaAIToolExecution } from '../toolExecution.mts';

export const getOrderDecisionLogInputSchema = z.strictObject({
  orderId: orderIdSchema,
});

export const getOrderDecisionLogToolContract = {
  execution: AvaAIToolExecution.Server,
  name: 'getOrderDecisionLog',
  inputSchema: getOrderDecisionLogInputSchema,
  outputSchema: orderLogsResultSchema,
} as const;
